import Button from "src/components/button/Button";
import { cheatSheetLink } from "@src/constants";
import ThumbsUpIcon from "src/assets/icons/thumbsup.svg?react";
import styles from "./RequiredLessonMaterials.module.scss";

function CheatSheetSection() {
  const handleViewCheatSheet = () => {
    window.open(cheatSheetLink, "_blank");
  };

  return (
    <div className={styles.matTipsView}>
      <div className={styles.tipsView}>
        <ThumbsUpIcon />
        <p className={styles.tipsText}>
          <strong>Tips</strong> for program implementation & lesson adaptations
        </p>
      </div>
      <Button
        label="View Cheat Sheet"
        size="small"
        className={styles.viewCheat}
        onClick={handleViewCheatSheet}
      />
    </div>
  );
}

export default CheatSheetSection;
